/**
 * Generate a URL-safe slug from a string.
 * Handles Swedish characters (å, ä, ö) and other diacritics.
 *
 * @param text - The input text to convert to a slug
 * @param maxLength - Optional maximum length (default: no limit)
 * @returns A lowercase, URL-safe string with underscores instead of spaces/special chars
 *
 * @example
 * generateSlug('Byta takplåt') // 'byta_takplat'
 * generateSlug('Målning av fasad') // 'malning_av_fasad'
 * generateSlug('Very Long Name', 10) // 'very_long_'
 */
export function generateSlug(text: string, maxLength?: number): string {
    let slug = text
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_|_$/g, '');

    if (maxLength && slug.length > maxLength) {
        slug = slug.substring(0, maxLength);
    }

    return slug;
}
